import styled from 'styled-components';
import { mediaQuery } from 'components';

export const BillingFormModalWrapper = styled.div`
  ${mediaQuery.medium`
    width: 600px;
  `}
`;
